var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PermissionItem"},[_c('i',{staticClass:"PermissionItem-Icon",class:[_vm.iconClass, _vm.modeClass]})])
}
var staticRenderFns = []

export { render, staticRenderFns }